/**
 * Put the page back at the top.
 *
 * Every public form on an agency site replaces the panel in place when it
 * succeeds: the fields become "Thanks, we'll be in touch". On a phone the
 * submit button is usually most of a screen below the top of that panel, so
 * the browser keeps its scroll position and the confirmation lands above the
 * fold, out of sight. What the person sees is a form that went blank, and
 * the commonest next thing they do is fill it in and send it again.
 *
 * Smooth UNLESS the reader has asked for less motion. A full-page smooth
 * scroll is one of the movements that provokes nausea in people with
 * vestibular disorders, and `prefers-reduced-motion` is how they say so.
 * Wrapped because `matchMedia` is missing in some embedded webviews, and an
 * exception here would take the confirmation down with it.
 */
export function scrollToTop() {
  try {
    const reduced = window.matchMedia
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
  } catch (e) {
    try { window.scrollTo(0, 0); } catch (e2) { /* nothing left to try */ }
  }
}

export default scrollToTop;
